export const BASE_URL = process.env.VUE_APP_BASE_API;
export const ERROR_OK = 200;
